import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const api = new URL(environment.apiBaseUrl, location.origin);
        const url = new URL(req.url, location.origin);
        const trusted = url.origin === api.origin &&
            (url.pathname === '/sanctum/csrf-cookie' || url.pathname === api.pathname || url.pathname.startsWith(api.pathname.replace(/\/$/, '') + '/'));
        if (!trusted) { return next.handle(req); }
        let headers = req.headers.delete('Authorization');
        if (!['GET', 'HEAD', 'OPTIONS'].includes(req.method)) {
            const token = document.cookie.split('; ').find(part => part.startsWith('GWC-XSRF-TOKEN='));
            if (token) { headers = headers.set('X-XSRF-TOKEN', decodeURIComponent(token.substring(15))); }
        }
        return next.handle(req.clone({withCredentials: true, headers})).pipe(catchError(error => {
            if (error instanceof HttpErrorResponse && error.status === 403 && error.error?.code === 'PASSWORD_CHANGE_REQUIRED') {
                location.assign('/change-password-required');
            }
            if (error instanceof HttpErrorResponse && error.status === 401 && !url.pathname.includes('/Auth/') && location.pathname !== '/sign-in') {
                location.assign('/sign-in');
            }
            return throwError(() => error);
        }));
    }
}
